<template>
  <div id="train">
    <div id="Return_Bar">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
    </div>
    <div id="text">
      <div class="boxstyle">
      </div>
      <div class="study-countdown" v-if="knowledge.knowledgeType == 'Pdf' && timerTimeValue">{{ timerTimeValue }}</div>
      <div class="video-player-box" v-if="knowledge.knowledgeType == 'Video'">
        <videoPlayer ref="videoPlayer" class="video-player" :options="playerOptions" @play="onPlayerPlay" @pause="onPause"
          @ended="onPlayerEnded"></videoPlayer>
      </div>
      <template v-if="knowledge.knowledgeType == 'Pdf'">
        <div id="pdf_viewer"></div>
      </template>
      <el-dialog title="提示" :visible.sync="currency" width="360px">
        <div class="currency_img"><img src="../../assets/images/voiceScene/currency_img.png" alt=""></div>
        <div class="currency_text">
          <div v-if="knowledgestate == 1">你已完成“<span class="left_span">{{ knowledgename }}</span>”的学习<br>接下来，请进行“<span
              class="left_span">{{ nextknowledgename }}</span>”的学习</div>
          <div v-if="knowledgestate == 2 && Coursestate == 'Exam' && tabstate == null">你已完成“<span class="left_span">{{
        knowledgename }}</span>”的{{ nowCoursestatetext }}<br>接下来，请进行一个测试</div>
          <div v-if="knowledgestate == 2 && Coursestate == 'Practice' && tabstate == null">你已完成“<span
              class="left_span">{{
        knowledgename }}</span>”的{{ nowCoursestatetext }}<br>接下来，请进行下一个练习</div>
          <div v-if="knowledgestate == 2 && Coursestate == 'Study' && tabstate == null">你已完成“<span class="left_span">{{
        knowledgename }}</span>”的{{ nowCoursestatetext }}<br>接下来，请进行下一个课程的学习</div>
          <div v-if="knowledgestate == 2 && tabstate == 2">你已完成“<span class="left_span">{{ categoryName
              }}</span>”的学习<br>接下来，请进行下一个阶段的学习</div>
          <div v-if="knowledgestate == 2 && tabstate == 1">你已完成{{ categoryName }}的学习</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="currency_button">
            <div class="determine" @click="determine" v-if="knowledgestate == 1">去学习</div>
            <div class="determine" @click="determine" v-if="knowledgestate == 2 && Coursestate == 'Exam'">去测试</div>
            <div class="determine" @click="determine" v-if="knowledgestate == 2 && Coursestate == 'Study'">继续学习</div>
            <div class="determine" @click="determine" v-if="knowledgestate == 2 && Coursestate == 'Practice'">去练习</div>
            <div class="otherdetermine" @click="goindex"
              v-if="knowledgestate == 2 && tabstate == 2 && dazhiJump == false">
              去报名并参加{{ nextcategoryName }}</div>
            <div class="otherdetermine" @click="goindex" v-if="knowledgestate == 2 && tabstate == 2 && dazhiJump">去学习
            </div>
            <div class="determine" @click="goindex" v-if="knowledgestate == 2 && tabstate == 1">我知道了</div>
          </div>
        </span>
      </el-dialog>
      <exam-dialog v-if="nextExamCourse" :id="id" :visible="examVisible" :courseId="nextCourseId"
        :tabMajorId="tabMajorId" :majorId="majorId" :type="type" :isListPage="false" :parent="parent"
        @callback="closeDialog"></exam-dialog>
    </div>
    <knowledge-dialog
    @handleChildEvent="handleChildEventMethod"
    :show="knowledgeDialogObj.visible" 
    :courseId="knowledgeDialogObj.courseId" 
    :knowledgeId="knowledgeDialogObj.knowledgeId" 
    :playSecondsAt="knowledgeDialogObj.playSecondsAt"
    @result="knowledgeResult"
    />
    <answer-result-dialog :isRight="answerResultDialogObj.isRight" :show="answerResultDialogObj.visible" @goonOrNot="goonOrNot"></answer-result-dialog>

    <!--图片附件，查看大图-->
    <div class="img-fix-bg" v-if="largerVisible">
      <div class="larger-box"><img :src="largerUrl"></div>
      <i class="el-icon-close close" @click="largerVisible=false"></i>
    </div>

  </div>
</template>

<script>
import PDFObject from '../../assets/js/pdfobject.min';
import examDialog from './examDialog';
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import knowledgeDialog from './videoDetail/knowledgeDialog.vue';
import answerResultDialog from './videoDetail/answerResultDialog.vue';
export default {
  components: {
    examDialog,
    videoPlayer,
    knowledgeDialog,
    answerResultDialog
  },
  data() {
    return {
      largerVisible: false,//查看上传图片之，大图
      largerUrl: null,//查看上传图片之，大图
      fbtType:this.$route.query.fbtType,
      id: this.$route.query.id, //技能提升-场景id
      courseId: this.$route.query.courseId, //课程id
      type: this.$route.query.type, //上级tab类型
      tabMajorId: this.$route.query.tabMajorId, //上级tab的id
      majorId: this.$route.query.majorId, //
      tjkId: this.$route.query.tjkId, //
      lastCourseId: null, //上一课程id
      nextCourseId: null, //下一课程id
      readTimeSeconds: null, //pdf最少阅读时间
      nextExamCourse: false, //下一课是否测试课程
      knowledge: {},
      curMajor: {
          majorScope : null
      },
      unlock: false, //下一课是否可点击
      height: 0, //pdf高度
      examVisible: false, //测试考试弹出层
      parent: this.$route.query.parent, //父级菜单
      timer: null,
      timerTimeValue: null,//界面倒计时数字显示
      knowledgeSeq: this.$route.query.knowledgeSeq,//知识点提交需要的参数
      currency: false,//知识点通用弹窗控制
      nextobject: {},//储存知识点接口数据
      nextknowledge: {},//下一个知识点
      nextcourseId: null,//下一个知识点或课程courseId
      tabIndex: null,//记录二级tab的位置
      CourseLevel: this.$route.query.CourseLevel,//知识点跳课程层级
      guidePopMsg: '',//弹窗提示
      knowledgestate: null,//弹窗文字类型
      knowledgename: '',//当前知识点或课程名称
      nextknowledgename: '',//下一个知识点或课程名称
      Coursestate: '',//接下跳转的课程状态
      nowCoursestate: '',//当前的课程状态
      nowCoursestatetext: '',//当前的课程状态的弹窗文字
      categoryName: '',//当前tab名字
      tabstate: null,//根据tab位置判断最后一个知识点的弹窗文字状态
      nextcategoryName: '',//下一个tab名字
      knowledgeId: this.$route.query.knowledgeId,//知识点id
      dazhiJump: false,//打字认证跳系统实操
      isReture: this.$route.query.isReture,//是否是服务台跳回
      timeUpdateInterval: null,
      playPositions: [],
      enableDrag:false,
      knowledgeDialogObj: {
        visible: false,
        knowledgeId: '',
        playSecondsAt: '',
        courseId: ''
      },
      answerResultDialogObj: {
        visible: false,
        isRight: false,
      },
      playerOptions: {
        autoplay: false,
        controls: true,
        sources: []
      }
    }
  },
  created() {
     this.$http.post(API_ROOT.college + '/videoDragTjk/enableDrag').then((res) => {
        this.enableDrag = res.data.data
      })
  },
  mounted() {
    this.height = document.body.clientHeight - 150;
    this.getCourseDetail();
  },
  beforeDestroy() {
    clearInterval(this.timeUpdateInterval);
  },
  methods: {
    handleChildEventMethod(data) {
        this.largerVisible = true;
        this.largerUrl = data;
    },
    goonOrNot(isRight){
      const player = this.$refs.videoPlayer.player;
      if (isRight) {
        player.play();
      } else {
        const currentTime = Math.floor(player.currentTime()) + 1; // 取整当前播放时间
        const idx = this.playPositions.indexOf(currentTime);
        if (idx != -1) {
          if (idx == 0) {
            this.seekVideo(0);
          }else {
            this.seekVideo(this.playPositions[idx - 1]);
          }
          player.play();
        }
      }
    },

    knowledgeResult(isRight){
      this.answerResultDialogObj = {
        visible: +new Date(),
        isRight: isRight
      }
    },
    onPlayerPlay() {
      if (this.enableDrag) {
        document.querySelector(".vjs-progress-control").style.pointerEvents = "auto";
      }
      const player = this.$refs.videoPlayer.player;
      this.timeUpdateInterval = setInterval(() => {
        const currentTime = Math.floor(player.currentTime()) + 1; // 取整当前播放时间
        if (this.playPositions && this.playPositions.length > 0){
          const idx = this.playPositions.indexOf(currentTime);
          if (idx != -1) {
            player.pause();
            this.knowledgeDialogObj = {
              visible: +new Date(),
              knowledgeId: this.knowledge.knowledgeId,
              courseId: this.knowledge.courseId,
              playSecondsAt: currentTime
            }
          }
        }
      }, 1000);
    },
    onPlayerEnded() {
      this.submitKnowledge();
    },
    onPause(){
      clearInterval(this.timeUpdateInterval);
    },
    seekVideo(time) {
      this.$refs.videoPlayer.player.currentTime(time);
    },
    goindex() {
      if (this.fbtType) {
        this.$router.back()
        return
      }
      this.$router.push({ path: '/train/index' })
    },
    // 返回按钮
    isreturn() {
      if(this.curMajor.majorScope == 'FbtOperate'){
          this.$router.back();
          return;
      }
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: this.courseId }).then(
        (res) => {
          var result = res.data;
          if (result.success) {
            if (this.isReture == 'yes') {
              this.$router.go(-1)
            } else {
              if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                this.$router.push({
                  path: '/train/Secondarylist', query: {
                    courseId: this.courseId, CourseLevel: this.$route.query.CourseLevel,
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId
                  }
                })
              } else if (this.CourseLevel == 3) {
                this.$router.push({
                  path: '/train/SpecialCourses', query: {
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId

                  }
                })
              } else {
                this.tabIndex = localStorage.getItem('tabIndex')
                this.$router.push({
                  path: '/train/index',
                  query: {
                    tabIndex: this.tabIndex, condition: true//判断是否是基础知识点跳课程
                  }
                });
              }
            }
          } else {
            this.$alert(result.msg);
          }
        },
        (res) => {
          this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        }
      );
    },
    initPdf(url) {
      var options = {
        pdfOpenParams: {
          navpanes: 0,
          toolbar: 0,
          statusbar: 0,
          view: "FitV",
          pagemode: "thumbs",
          page: 1
        },
        forcePDFJS: true,
        PDFJS_URL: (process.env.NODE_ENV === 'development' ? '' : '/tjkStudy') + '/static/pdfjs-2.6.347/web/viewer.html'
      };
      if (PDFObject.supportsPDFs) {
        $('#pdf_viewer').height(this.height);
        PDFObject.embed(url, "#pdf_viewer", options)
      }
    },
    getCourseDetail() {
      var self = this;
      this.$http.post(API_ROOT.college + '/course/getGuideDialog', { 'courseId': this.courseId, 'knowledgeId': this.knowledgeId }).then(res => {
        var result = res.data;
        if (result.success) {
          this.knowledge = result.data.current
          this.curMajor = result.data.curMajor
          if (this.knowledge.knowledgeType == 'Video') {
            this.playPositions = result.data.playPositions //知识点跳知识点
            this.playerOptions.sources = [{
              type: "video/mp4",
              src: this.knowledge.videoUrl
            }];
          }
          if (result.data.playSecondsAt) {
            setTimeout(() => {
              this.$refs.videoPlayer.player.currentTime(result.data.playSecondsAt);
            }, 500);
          }
          this.nextobject = result.data
          if (this.nextobject.next) { this.knowledgeId = this.nextobject.next.knowledgeId }
          if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
            self.knowledgestate = 1//知识点跳知识点
            self.knowledgeId = self.nextobject.next.knowledgeId
            self.knowledgename = self.nextobject.current.title
            self.nextknowledgename = self.nextobject.next.title
            console.log('===' + JSON.stringify(this.nextobject))
          } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
            self.knowledgestate = 2//知识点跳课程
            self.knowledgename = self.nextobject.currentCourse.courseName
            self.nextknowledgename = self.nextobject.nextCourse.courseName
            if (this.nextobject.currentCourse.courseType == 'Exam') {
              this.nowCoursestate = 'Exam'
              this.nowCoursestatetext = '测试'
            } else if (this.nextobject.currentCourse.courseType == 'Integrate' && this.nextobject.currentCourse.assitantType) {
              if (this.nextobject.currentCourse.assitantType == 'CallOutAbilityCheck') {
                this.nowCoursestate = 'Exam'
                this.nowCoursestatetext = '测试'
              } else {
                this.nowCoursestate = 'Practice'
                this.nowCoursestatetext = '练习'
              }

            } else if (this.nextobject.currentCourse.courseType == 'Integrate' && !this.nextobject.currentCourse.assitantType) {
              this.nowCoursestate = 'Study'
              this.nowCoursestatetext = '学习'
            }

            if (this.nextobject.nextCourse.courseType == 'Exam' || this.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              this.Coursestate = 'Exam'
            } else if (this.nextobject.nextCourse.courseType == 'Integrate' && this.nextobject.nextCourse.assitantType) {
              this.Coursestate = 'Practice'
            } else if (this.nextobject.nextCourse.courseType == 'Integrate' && !this.nextobject.nextCourse.assitantType) {
              this.Coursestate = 'Study'
            }
          } else if (this.nextobject.nextCategory) {
            this.knowledgestate = 2
            this.categoryName = this.nextobject.currentCategory.categoryName
            var ismajorId = localStorage.getItem('majorId')
          } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
            this.knowledgestate = 2
            this.categoryName = this.nextobject.currentCategory.categoryName
          }
          this.$nextTick(function () {
            if (this.knowledge.knowledgeType == 'Pdf') {
              this.initPdf(this.knowledge.pdfUrl);
              if (!this.unlock) {
                this.countdown(this.knowledge.readTimeSeconds);
              }
            } else if (this.knowledge.knowledgeType == 'Video') {
            }
          });
        } else {
          this.$alert(result.msg);
        }
      }, res => {
        this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      })

    },
    //pdf倒计时
    countdown(endTime) {
      var self = this;
      self.timerTimeValue = '学习倒计时：' + self.formatCountdown(endTime);
      self.timer = setInterval(function () {
        endTime--;
        self.timerTimeValue = '学习倒计时：' + self.formatCountdown(endTime);
        if (endTime <= 0) {
          self.unlock = true;

          self.submitKnowledge();
          clearInterval(self.timer);
          self.timerTimeValue = '';
        }
      }, 1000);
    },
    //将剩余秒数格式化为 分:秒
    formatCountdown(totalSeconds) {
      if (!totalSeconds || totalSeconds < 0 || isNaN(totalSeconds)) {
        totalSeconds = 0;
      }
      totalSeconds = Math.floor(totalSeconds);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      return pad(minutes) + ':' + pad(seconds);
    },
    //视频/pdf学习完成后提交
    submitKnowledge() {
      let data = {
        'courseId': this.courseId,
        'knowledgeSeq': this.knowledge.knowledgeSeq,
        'knowledgeId': this.knowledge.knowledgeId,
        'assitant': true
      }
      this.$http.post(API_ROOT.college + '/course/submitKnowledgeXlk', data).then(res => {
        var result = res.data;
        if (result.success) {
          this.currency = true
          var ismajorId = localStorage.getItem('majorId')
          this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk", { majorId: ismajorId })
            .then(
              (res) => {
                var result = res.data;

                if (result.success) {
                  let relist = result.data
                  if (this.nextobject.nextCategory) {
                    if (this.nextobject.nextCategory == null) {
                      this.tabstate = 1
                    } else {
                      this.tabstate = 2
                      this.nextobject.nextCategory.assitantType
                      relist.forEach((item, index) => {
                        if (item.assitantType == this.nextobject.nextCategory.assitantType) {
                          if (this.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                            localStorage.setItem('tabIndex', index)
                            localStorage.setItem('majorId', item.majorId)
                            if (this.nextobject.theoryBadge == false) {
                              this.nextcategoryName = '理论培训'
                            } else {
                              this.nextcategoryName = '实操培训'
                            }
                          } else if (this.nextobject.nextCategory.assitantType == 'VoiceUpgradeSkill') {
                            localStorage.setItem('tabIndex', index)
                            localStorage.setItem('majorId', item.majorId)
                            this.nextcategoryName = '语音技能提升'
                          }
                          else if (this.nextobject.nextCategory.assitantType == 'SysOperate') {
                            this.dazhiJump = true
                            localStorage.setItem('tabIndex', index)
                            localStorage.setItem('majorId', item.majorId)
                            localStorage.setItem('categoryId', item.categoryId)

                          } else {
                            localStorage.setItem('tabIndex', index)
                            localStorage.setItem('majorId', item.majorId)
                            localStorage.setItem('categoryId', item.categoryId)
                            this.nextcategoryName == item.categoryName
                            this.categoryName = this.nextobject.currentCategory.categoryName
                          }
                        }
                      })
                    }
                  }
                  else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
                    this.knowledgestate = 2
                    this.categoryName = this.nextobject.currentCategory.categoryName
                    this.tabstate = 1
                  }
                } else {
                  this.$alert(result.msg);
                }
              }, (res) => {
                this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
              })
        } else {
          this.$alert(result.msg);
        }
      }, res => {
        this.$alert("AJAX请求接口异常（/course/submitKnowledge）！");
      })
    },
    lastStudy() {
      clearInterval(this.timer);
      window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.lastCourseId + '&id=' + this.id + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId + '&majorId=' + this.majorId + '&parent=' + this.parent;
    },
    nextStudy() {
      clearInterval(this.timer);
      if (this.unlock) {
        window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.nextCourseId + '&id=' + this.id + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId + '&majorId=' + this.majorId + '&parent=' + this.parent;
      }
    },
    endStudy() {
      clearInterval(this.timer);
      if (this.parent == 'jineng') {
        this.$router.push({ path: '/train/childCourseList', query: { id: this.id, type: this.type, tabMajorId: this.tabMajorId, majorId: this.majorId } });
      } else {
        this.$router.push({ path: '/train/index', query: { type: this.type, tabMajorId: this.tabMajorId } });
      }
    },
    showExamDialog() {
      if (!this.unlock) {
        return false;
      }
      this.examVisible = true;
    },
    closeDialog(val) {
      this.examVisible = val;
    },
    //点击前往下一个课程或知识点
    determine() {
        var self = this;
      if(!!this.nextobject.nextCourse && this.nextobject.nextCourse.courseType == 'Exam'){
          this.nextcourseId = this.nextobject.nextCourse.courseId//进这儿了
          if('fbtExamCourse' == this.nextobject.nextCourse.assitantType){
              window.location.href = '/tjkStudy/train/examDetail?trainFlag=fbtTrain&assitantType=fbtTrain&courseId=' + this.nextcourseId;
          }else{
            this.beginExam();
          }
      }
      //若是淘系培训的，则跳到
      var nextC = this.nextobject.nextCourse;
      var assitantType = nextC ? nextC.assitantType : null;
      if (assitantType === "qianniuplugin") {
          this.$router.replace({name: 'fbtQianniu', query:{courseId:nextC.courseId} }); return;
      } else if (assitantType === "qianniupluginexam") {
          this.$router.replace({name: 'fbtQianniuExam', query:{courseId:nextC.courseId} }); return;
      }else if (assitantType === "jingmaiplugin") {
          this.$router.replace({name: 'fbtJingmai', query:{courseId:nextC.courseId} }); return;
      }else if (assitantType === "jingmaipluginexam") {
          this.$router.replace({name: 'fbtJingmaiExam', query:{courseId:nextC.courseId} }); return;
      }else if (assitantType === "feigeplugin") {
          this.$router.replace({name: 'fbtDoudian', query:{courseId:nextC.courseId} }); return;
      }else if (assitantType === "feigepluginexam") {
          this.$router.replace({name: 'fbtDoudianExam', query:{courseId:nextC.courseId} }); return;
      }
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        var assitantType = this.nextobject.next.assitantType;
        if (assitantType == 'qianniu' || assitantType == 'qianniuexam' || assitantType == 'workorderjushuitan' || assitantType == 'workorderjushuitanexam' || assitantType == 'jingmai' || assitantType == 'jingmaiexam' || assitantType == 'primary' || assitantType == 'middle' || assitantType == 'wpsexcel' || assitantType == 'wpsexcelexam' || assitantType == 'sougouinput' || assitantType == 'sougouinputexam' || assitantType == 'feige' || assitantType == 'feigeexam') {
          this.$router.push({
            path: '/train/OnInline',
            query: {
              type: this.nextobject.next.assitantType,
              courseId: this.nextobject.next.courseId,
              knowledgeSeq: this.nextobject.next.knowledgeSeq,
              knowledgeId: this.nextobject.next.knowledgeId
            }
          })
        }else if(assitantType == 'fbt'){
            this.$router.replace({path: '/train/FBT/jingmaiChat', query: {sceneId: this.nextobject.next.courseId}});
        } else {
          this.nextcourseId = this.nextobject.next.courseId;
          //若下一知识点是下载【没有页面，会白屏的】，跳到知识点列表页面
          if(this.nextobject.next.assitantType == 'downLink'){
              window.location.href = "/tjkStudy/train/Secondarylist?courseId=" + self.courseId + '&CourseLevel=' + self.CourseLevel + '&sceneId=' + self.$route.query.sceneId;
          }else{
              window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId
          }
        }
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId
        this.toStudy()
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId//进这儿了
        this.gotoStudy()
      } else if (this.nextobject.nextCategory) {
        this.$router.push({ path: '/train/index' })
      } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
        this.$router.push({ path: '/train/index' })
      }
    },
    // 进入考试
    beginExam(courseId) {
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.nextcourseId;
    },
    toStudy() {
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: this.nextcourseId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                this.$router.push({ path: '/train/Secondarylist', query: { courseId: this.nextcourseId } })
              } else if (this.CourseLevel == 3) {
                this.$router.push({
                  path: '/train/SpecialCourses', query: {
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId

                  }
                })
              } else if (result.data.knowledgeRecordFullList.length == 1) {
                window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId
              }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          }
        );
    },
    gotoStudy() {
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: this.nextcourseId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                this.$router.push({ path: '/train/Secondarylist', query: { courseId: this.nextcourseId } })
              } else if (this.CourseLevel == 3) {
                this.$router.push({
                  path: '/train/SpecialCourses', query: {
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId
                  }
                })
              }
              else {
                this.tabIndex = localStorage.getItem('tabIndex')
                this.$router.push({
                  path: '/train/index',
                  query: {
                    tabIndex: this.tabIndex,
                    condition: true//判断是否是基础知识点跳课程
                  }
                });
              }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          }
        );
    },
  }
}
</script>

<style lang="less" scoped>
.video-player-box {
  max-height: 900px !important;
}

.video-player {
  display: flex;
  justify-content: center;
  // 禁止拖动进度条
  /deep/ .vjs-progress-control{
    pointer-events: none;
  }
  /deep/ .vjs-fullscreen-control{
    visibility: hidden !important;
  }
  /deep/ .video-js{
    max-height: 900px !important;
    background-color: transparent !important;
  }
  /deep/ .vjs-big-play-button{
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%,-50%);
  }
}

#train {
  padding: 0;
}

#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
}

/deep/.el-icon-arrow-left {
  margin-top: 5px;
}

#text {
  background: #f6f5f8;
  width: 100%;
  padding: 20px 20px;
}

.study-countdown {
  display: inline-block;
  margin: 5px 0;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
}

.isreturn {
  color: #000;
  cursor: pointer;
}

.boxstyle {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.timestyle {
  margin: 0 20px;
  height: 28px;
  line-height: 28px;
}

/deep/.el-dialog {
  border-radius: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #E9E9E9;
}

/deep/.el-dialog__title {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #262626;
}

.currency_img {
  width: 85px;
  height: 64px;
  margin: 0 auto;
  margin-bottom: 12px;
}

.currency_img>img {
  width: 100%;
  height: 100%;
}

.currency_text {
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 20px;
}

.currency_text>span {
  color: #497AF2
}

.cancel {
  width: 80px;
  height: 28px;
  background: #E1E1E1;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #717171;
  text-align: center;
  line-height: 28px;
  margin-right: 10px;
}

.determine {
  width: 80px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.currency_button {
  display: flex;
  justify-content: center;
}

.left_span {
  color: #497AF2;
}

.otherdetermine {
  padding: 0px 15px 0px 15px;
  height: 33px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 33px;
  cursor: pointer;
}

  //------------大图预览begin------------
  .img-fix-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, .6);
    .larger-box {
      width: 100%;
      height: 100%;
      text-align: center;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .close {
      position: absolute;
      right: 30px;
      top: 30px;
      color: #fff;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .offline-footer {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #dadbe3;
    padding: 12px 30px;
    z-index: 10;
  }
  .offline-footer /deep/ .el-form {
    .el-button {
      padding: 10px 35px;
    }
    .el-form-item {
      margin-right: 30px;
    }
    .remark {
      width: 250px;
      height: 36px;
      position: relative;
      .el-textarea {
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          line-height: 36px;
          padding-left: 15px;
        }
      }
    }
  }
  //------------大图预览end------------
</style>



// WEBPACK FOOTER //
// ./src/page/train/vedioDetail.vue